/**
 * WordPress dependencies
 */
import { Button, ButtonGroup } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

const tabOptions = [
    {
        label: __('Normal', 'progressmatify-blocks'),
        value: 'normal'
    },
    {
        label: __('Hover', 'progressmatify-blocks'),
        value: 'hover'
    }
];
const SwitcherControl = ({ normal, hover, options = [], className }) => {
    const [tab, setTab] = useState('normal');

    const Tabs = options.length > 0 ? options : tabOptions;

    return (
        <div className={classNames('progressmatify-control-container', 'progressmatify-switcher', 'progressmatify-mb-24', className)}>
            <ButtonGroup>
                {Tabs &&
                    Tabs.map((item, index) => {
                        return (
                            <Button
                                key={index}
                                className={`switcher-button ${tab === item.value ? 'progressmatify-active' : ''}`}
                                onClick={() => setTab(item.value)}
                            >
                                {item.label}
                            </Button>
                        );
                    })}
            </ButtonGroup>
            <div className="progressmatify-switcher-content">
                {tab === 'normal' && <div className="progressmatify-normal-content">{normal}</div>}
                {tab === 'hover' && <div className="progressmatify-hover-content">{hover}</div>}
            </div>
        </div>
    );
};

export default SwitcherControl;
